module.exports = __webpack_public_path__ + "static/media/heycar_3.3c61a222.png";